import React from 'react';

const HeaderTable = ({ data }) => {
  return (
    <div className="cen-header-table">
      {data.map((el, i) => (
        <span key={i}>{el}</span>
      ))}
    </div>
  );
};

export default HeaderTable;